import FolderPath from './FolderPath.component';

export default FolderPath;